/**
 * Top bar shell: delegates Open / Closed / All tabs to RmaListTabsBar and hosts the Create RMA action.
 */
import "./rma-list-top-bar.scss";
import { observer } from "mobx-react";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import dashboardTranslationsStore from "../../../../../dashboard-translation/stores/dashboard-translations-store";
import RmaListTabsBar from "../rma-list-tabs-bar/rma-list-tabs-bar";
import CreateRmaListAction from "../../../components/create-rma-list-action/create-rma-list-action";

interface IProps {
    isLoading: boolean;
}

const RmaListTopBar: React.FC<IProps> = observer(({ isLoading }) => {
    const { getTranslation } = useDashboardTranslation();
    const scope = "dashboard-returns-page";

    return (
        <div className="rma-list-top-bar">
            {!dashboardTranslationsStore.isLoading && (
                <RmaListTabsBar isLoading={isLoading} />
            )}
            <div className="rma-list-top-bar__actions">
                {!dashboardTranslationsStore.isLoading && (
                    <CreateRmaListAction getCreateRmaLabel={() => getTranslation("CREATE_RMA", scope)} />
                )}
            </div>
        </div>
    );
});

export default RmaListTopBar;
